import { useEffect, useRef, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, FileUploadChild, OpenImage, convertToNumber, deleteData, handleDateChange, initializeFilterData } from '../CommonComponents/CustomHooks';
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const EventMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        eventID: '',
        eventCode: '',
        eventName: '',
        helplineNo: '',
        eventImageName: '',
        eventImageExt: '',
        eventBase64: '',
        client: '',
        eventActiveTill: '',
        downloadButtonText: '',
        isOTPRequired: true,
        isOTPRequiredEmail: true,
        isActive: true,
    });

    const getEventMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowEventMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async () => {
        setFormData({
            eventID: '',
            eventCode: '',
            eventName: '',
            helplineNo: '',
            eventImageName: '',
            eventImageExt: '',
            eventBase64: '',
            client: '',
            eventActiveTill: '',
            downloadButtonText: '',
            isOTPRequired: true,
            isOTPRequiredEmail: true,
            isActive: true,
        });
        filterData.SearchText = '';
        getEventMasterData();
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateEventMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditEventMaster`, { EventMasterID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else if (editData.status === 'SUCCESS') {
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteEventMaster`, { EventMasterID: id }, getEventMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }
    const handleChange1 = (event, value) => {
        getEventMasterData(value);
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    useEffect(() => {
        getEventMasterData()
        document.title = 'Event Master'
        inputrefs.current['txtEventCode'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Event Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-12 col-lg-12'>
                            <div className='row'>
                                <InputBox
                                    id="txtEventCode"
                                    label='Event Code'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEventName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    maxLength='10'
                                    placeholder='Event Code'
                                    name='EventCode'
                                    value={formData.eventCode}
                                    onChange={(e) => setFormData({ ...formData, eventCode: e.target.value })}
                                />
                                <InputBox
                                    id="txtEventName"
                                    type="text"
                                    label='Event Name'
                                    required={true}
                                    placeholder="Event Name"
                                    maxLength='200'
                                    value={formData.eventName}
                                    onChange={(e) => setFormData({ ...formData, eventName: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtClient'].focus()
                                        }
                                    }}
                                />
                                <AutoCompleteBoxNew
                                    id="txtClient"
                                    placeholder="Client"
                                    label={'Client'}
                                    maxLength="50"
                                    required={true}
                                    value={formData.client || ''}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEnventActiveTill'].focus()
                                        }
                                    }}
                                    autocompleteType='GetClientData'
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, client: newInputValue })
                                        }
                                    }}
                                />
                                <DateBox
                                    id='txtEnventActiveTill'
                                    required={true}
                                    inputrefs={inputrefs}
                                    label='Event Active Till'
                                    placeholder='Event Active Till'
                                    selected={formData.eventActiveTill === '' ? '' : new Date(formData.eventActiveTill)}
                                    onChange={(e) => handleDateChange(e, setFormData, formData, 'eventActiveTill')}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtDownloadButtonText'].focus() };
                                    }}

                                />
                                <InputBox
                                    id="txtDownloadButtonText"
                                    placeholder="Download Button Text"
                                    autoComplete="off"
                                    maxLength='50'
                                    required={true}
                                    label='Download Button Text'
                                    value={formData.downloadButtonText}
                                    onChange={(e) => setFormData({ ...formData, downloadButtonText: (e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtHelplineNo'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtHelplineNo"
                                    placeholder="Helpline No"
                                    autoComplete="off"
                                    maxLength='15'
                                    required={true}
                                    label='Helpline No'
                                    value={formData.helplineNo}
                                    onChange={(e) => setFormData({ ...formData, helplineNo: convertToNumber(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEventImage'].focus()
                                        }
                                    }}
                                />
                                <div
                                    className='col-sm-3 cntrl-width sale'
                                    ref={ref => (inputrefs.current['txtEventImage'] = ref)}  >
                                    <label className="form-label">Event Image </label>
                                    <FileUploader
                                        classes="upload-section file-uploader"
                                        label="Event Image"
                                        handleChange={async (file) => {
                                            let extArr = (file.name).split(".");
                                            if (file) {
                                                try {
                                                    if (file.size < 2 * 1024 * 1024) {
                                                        const reader = new FileReader();
                                                        reader.readAsDataURL(file);
                                                        reader.onload = () => {
                                                            let logo = (reader.result).split(",")[1];
                                                            setFormData({
                                                                ...formData,
                                                                eventBase64: logo,
                                                                eventImageExt: extArr[1],
                                                                eventImageName: extArr[0],
                                                            });
                                                        };
                                                    } else {
                                                        NotificationSound('ERROR', 'Please upload maximum 2 mb image .!')
                                                    }
                                                } catch (error) {
                                                    console.error("File handling error:", error);
                                                    alert("An error occurred while processing the file. Please try again.");
                                                }
                                            }
                                        }}
                                        name="file"
                                        types={["JPG", "PNG"]}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === "Tab") {
                                                e.preventDefault();
                                                inputrefs.current["txtInvoiceNo"].focus();
                                            }
                                        }}
                                    >
                                        <FileUploadChild
                                            label=""
                                            message={`${formData.eventImageName}.${formData.eventImageExt}`}
                                            types={["JPG", "PNG"]}
                                        />
                                    </FileUploader>
                                    {formData.eventBase64 ?
                                        <i className="fa fa-image me-2"
                                            title='show Image'
                                            onClick={() => { OpenImage(formData.eventBase64, formData.eventImageExt) }}
                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                        /> : <span className='text-danger' style={{ fontSize: '12px' }}>maximum size : 2MB</span>
                                    }
                                </div>
                                <Switch
                                    inputrefs={inputrefs}
                                    label='OTP Required (Mobile)'
                                    checked={formData.isOTPRequired}
                                    id='txtIsOTPRequired'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtIsOTPRequiredEmail'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isOTPRequired: e.target.checked })}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='OTP Required (Email)'
                                    checked={formData.isOTPRequiredEmail}
                                    id='txtIsOTPRequiredEmail'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isOTPRequiredEmail: e.target.checked })}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />
                            </div>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                Export={false}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'EventMaster'}
                handleFilter={() => {
                    getEventMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default EventMaster;